import { connect } from 'react-redux';

import { FiltersClearButton } from 'src/components/Filters/components/FiltersClearButton';
import { clearFiltersAction } from '../../../actions/filters';

const mapDispatchToProps = (dispatch) => ({
  onClick: (e) => {
    // запрещаем всплытие при нажатии на сброс фильтров,
    // тк карточка отеля обернута в onClick
    e.stopPropagation();

    return dispatch(clearFiltersAction());
  },
});

const FiltersClear = connect(null, mapDispatchToProps)(FiltersClearButton);
export { FiltersClear };
